import { ChartNoAxesColumn, Zap } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Bottom nav:
 *   [Log] [Patterns]
 *
 * - Log       home base — the habits you're tracking, one tap each to capture
 *             an urge, plus the feed of what's been logged. A habit's own
 *             four-step page lives under /h/, so Log stays active there.
 * - Patterns  what the logs say about one habit: which cue keeps showing up,
 *             and where it wins.
 */
export const habitLoopBottomNav: BottomNavItem[] = [
  {
    id: 'log',
    label: 'Log',
    icon: Zap,
    href: '/apps/habit-loop',
    matchPrefixes: ['/apps/habit-loop/h/'],
  },
  {
    id: 'patterns',
    label: 'Patterns',
    icon: ChartNoAxesColumn,
    href: '/apps/habit-loop/patterns',
  },
]
